import { BlokkieFooter } from '@tikkie/blokkie';
import { useTranslation } from 'react-i18next';

import { useTikkieCookies } from '@/components/cookie-banner/use-tikkie-cookies.tsx';

export function Footer() {
  const { t } = useTranslation();
  const { handleCookies, currentCookiePreferences } = useTikkieCookies();

  return (
    <BlokkieFooter
      id="claim-footer"
      cookieSettingsModalLink={t('footer.cookies_url')}
      onCookieAccept={handleCookies}
      cookiePreferences={currentCookiePreferences()}
      links={[
        {
          href: t('footer.privacy_url'),
          children: t('footer.privacy'),
        },
        {
          href: t('footer.terms_url'),
          children: t('footer.terms'),
        },
      ]}
    />
  );
}
